import _ from "lodash"

//dnd-kit components
import { DragOverlay } from "@dnd-kit/core"
import { snapCenterToCursor } from "@dnd-kit/modifiers"
import formulaBuilderTypes from "./formulaBuilderTypes"
import RenderFormulaConnector from "./RenderFormula/RenderFormulaConnector"
import DragOverlayQuestion from "./DragOverlays/DragOverlayQuestion"
import DragOverlayGroup from "./DragOverlays/DragOverlayGroup"
import DragOverlayDragIcon from "./DragOverlays/DragOverlayDragIcon"
import elementTypes from "../Elements/elementTypes"
import DragOverlayFunction from "./DragOverlays/DragOverlayFunction"
import DragOverLayOption from "./DragOverlays/DragOverlayOption"

export default function FormulaBuilderDragOverlay({ object }) {
  let description = "Unknown type"
  let currentType = object?.type

  if (!currentType && object?.formulaOrder) {
    if (object.formulaOrder.question) {
      currentType = formulaBuilderTypes.draggableTypes.formulaQuestion
    } else if (object.formulaOrder.group) {
      currentType = formulaBuilderTypes.draggableTypes.group
    } else if (object.formulaOrder.value) {
      currentType = formulaBuilderTypes.draggableTypes.number
    } else if (object.formulaOrder.option) {
      currentType = formulaBuilderTypes.draggableTypes.option
    }
  }

  switch (currentType) {
    case formulaBuilderTypes.draggableTypes.question:
      description = (
        <DragOverlayDragIcon
          icon={
            elementTypes.findTypeProfile(object.object?.question?.type)?.icon
          }
        />
      )
      break
    case formulaBuilderTypes.draggableTypes.number:
      description = (
        <DragOverlayDragIcon
          icon={elementTypes.findTypeProfile(currentType)?.icon}
        />
      )
      break
    case formulaBuilderTypes.draggableTypes.formulaQuestion:
      description = <DragOverlayQuestion draggedObject={object} />
      break
    case formulaBuilderTypes.draggableTypes.function:
      description = <DragOverlayFunction object={object} />
      break
    case formulaBuilderTypes.draggableTypes.group:
      description = <DragOverlayGroup draggedObject={object} />
      break
    case formulaBuilderTypes.draggableTypes.operator:
      description = (
        <RenderFormulaConnector
          connector={object.object.name}
          formulaId={formulaBuilderTypes.droppableIds.connector}
          overConnectorId={`${formulaBuilderTypes.droppableIds.connector}${formulaBuilderTypes.droppableIds.connector}`}
        />
      )
      break
    case formulaBuilderTypes.draggableTypes.option:
      description = <DragOverLayOption draggedObject={object} />
      break
    default:
      break
  }

  return (
    <DragOverlay
      modifiers={[snapCenterToCursor]}
      style={{ BorderStyle: "solid", borderWidth: "2px" }}
    >
      {description}
    </DragOverlay>
  )
}
